var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3572 3.25875L19.3497 3.26719L13 10.0472V15.2494C13.0003 15.4968 12.9395 15.7405 12.8229 15.9587C12.7062 16.1769 12.5375 16.3628 12.3315 16.5L9.33154 18.5006C9.10546 18.6512 8.84274 18.7376 8.57141 18.7505C8.30008 18.7635 8.03032 18.7025 7.79095 18.5741C7.55157 18.4457 7.35155 18.2547 7.21225 18.0215C7.07294 17.7883 6.99957 17.5216 6.99998 17.25V10.0472L0.650288 3.26719L0.642788 3.25875C0.44755 3.04389 0.318859 2.77699 0.272325 2.49043C0.225791 2.20387 0.263415 1.90996 0.380632 1.64436C0.497849 1.37876 0.689622 1.15288 0.932686 0.994131C1.17575 0.835378 1.45966 0.750572 1.74997 0.75H18.25C18.5405 0.750028 18.8248 0.834441 19.0683 0.992982C19.3118 1.15152 19.504 1.37737 19.6216 1.64308C19.7391 1.90878 19.777 2.20292 19.7305 2.48973C19.6841 2.77655 19.5554 3.04371 19.36 3.25875H19.3572Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFilledIcon);
export default __webpack_public_path__ + "static/media/filterFilledIcon.fb83c2438278f4dcf6160b86726cb0b8.svg";
export { ForwardRef as ReactComponent };